import React from 'react';
import styled, { keyframes } from 'styled-components';

interface ProgressBarProps {
  percent: number;
  isFailed?: boolean;
}

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const StyledProgressBar = styled.div<ProgressBarProps>`
  height: 6px;
  width: 100%;
  border-radius: 4px;
  background-color: ${({ theme, isFailed }) =>
    isFailed ? theme.danger.blendToBackground(200) : theme.secondary.blendToBackground(150)};
  position: relative;
  overflow: hidden;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05) inset;

  &:before {
    content: '';
    background-color: ${({ theme, isFailed }) => (isFailed ? theme.danger.background : theme.success.background)};
    background-image: ${({ theme, isFailed, percent }) =>
      !isFailed && percent > 0
        ? `linear-gradient(
      90deg,
      ${theme.success.background} 0%,
      ${theme.success.background} 40%,
      ${theme.success.blendToBackground(700)} 60%,
      ${theme.success.background} 80%,
      ${theme.success.background} 100%,
    )`
        : 'none'};
    background-size: ${({ isFailed, percent }) => (!isFailed && percent > 0 ? '200% 100%' : 'auto')};
    background-position: ${({ isFailed, percent }) => (!isFailed && percent > 0 ? '-200% 0' : '0 0')};
    animation: ${({ isFailed, percent }) => (!isFailed && percent > 0 ? shimmer : 'none')} 4s linear infinite;
    border-radius: inherit;
    display: block;
    height: 100%;
    width: 100%;
    transform: translateX(${({ percent }) => `-${100 - percent}%`});
    transition: transform 0.3s ease;
  }
`;

export const ProgressBar: React.FC<ProgressBarProps> = ({ percent, isFailed }) => {
  return <StyledProgressBar percent={percent} isFailed={isFailed} />;
};
